import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';

export const Wrapper = styled.div<{ oneImage: boolean }>(
    ({ theme }) => ({
        display: 'grid',
        flexGrow: 1,
        gridTemplateColumns: '160px auto',
        gap: theme.space[4],
        marginBottom: theme.space[6],
        padding: `${theme.space[5]} ${theme.space[5]} 0 0`,
    }),
    ifProp('oneImage', {
        gridTemplateColumns: `auto`,
    })
);

export const ImageList = styled.ul(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.space[2],
    alignContent: 'start',
}));

export const ImageListItem = styled.li({
    position: 'relative',
});

export const ImageButton = styled.button<{ isActiveMedia: boolean }>(
    ({ theme }) => ({
        cursor: 'pointer',
        borderStyle: 'none',
        outline: 'none',
        position: 'relative',
        display: 'block',
        backgroundColor: theme.colors.white,
        width: 70,
        height: 70,
    }),

    ifProp('isActiveMedia', ({ theme }) => ({
        ':after': {
            position: 'absolute',
            content: '""',
            width: '100%',
            height: 2,
            bottom: -2,
            left: 0,
            backgroundColor: theme.colors.black,
        },
    }))
);

export const BigImage = styled.div(({ theme }) => ({
    borderStyle: 'none',
    outline: 'none',
    position: 'relative',
    minHeight: '70vh',
    backgroundColor: theme.colors.white,
}));
